<template>
  <div class="gripper">
    <div class="gripper__grip" v-for="n in 6" :key="n"></div>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
  .gripper {
    height: 18px;
    width: 21px;
    padding: 6px;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto auto;

    &__grip {
      width: 1px;
      height: 1px;
      border-radius: 1px;
      background-color: $black;
    }
  }

</style>
